import { render, staticRenderFns } from "./Styleguide.vue?vue&type=template&id=30144aed&scoped=true"
import script from "./Styleguide.vue?vue&type=script&lang=js"
export * from "./Styleguide.vue?vue&type=script&lang=js"
import style0 from "./Styleguide.vue?vue&type=style&index=0&id=30144aed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30144aed",
  null
  
)

export default component.exports